import { useState, useEffect } from 'react'
import { Container } from 'reactstrap'
import { COMPANY_PROPOSAL_STATUS } from 'components/Company/constants'
import s from './Proposals.scss'
import { Tabs } from 'components/ideal-core-ui'
import { ProposalsTable } from 'components/common/ProposalsTable'

const Proposals = ({ proposals, wonProposals, lostProposals }) => {
  const [companyProposals, setCompanyProposals] = useState(proposals)

  useEffect(() => {
    setCompanyProposals(proposals)
  }, [proposals])

  const filterProposals = status => {
    switch (status) {
      case COMPANY_PROPOSAL_STATUS.WON:
        setCompanyProposals(wonProposals)
        break
      case COMPANY_PROPOSAL_STATUS.LOST:
        setCompanyProposals(lostProposals)
        break
      default:
        setCompanyProposals(proposals)
    }
  }

  return (
    <Container>
      <section className={s.proposalsContainer}>
        <Tabs
          activeTabKey="active"
          className={s.main}
          tabs={[
            {
              key: 'active',
              label: 'Active',
              cb: () => filterProposals(COMPANY_PROPOSAL_STATUS.ACTIVE),
              value: <ProposalsTable companyProposals={companyProposals} label="Active Proposals" />
            },
            {
              key: 'won',
              label: 'Won',
              cb: () => filterProposals(COMPANY_PROPOSAL_STATUS.WON),
              value: <ProposalsTable companyProposals={companyProposals} label="Won Proposals" />
            },
            {
              key: 'lost',
              label: 'Lost',
              cb: () => filterProposals(COMPANY_PROPOSAL_STATUS.LOST),
              value: <ProposalsTable companyProposals={companyProposals} label="Lost Proposals" />
            }
          ]}
        />
      </section>
    </Container>
  )
}

export default Proposals
